import type { ChannelType } from "./notifications-admin-api.ts";

/** Feature flag (a role name on the user) that unlocks the MCP channel. */
export const MCP_EVENTS_FLAG = "mcp_events_channel";

/** The channel only exposed to users holding {@link MCP_EVENTS_FLAG}. */
export const MCP_EVENT_CHANNEL: ChannelType = "mcp_event";

/** Drops the MCP channel unless the flag is on; other channels untouched. */
export function visibleChannels<T extends string>(channels: readonly T[], mcpEventsEnabled: boolean): T[] {
  return channels.filter((channel) => mcpEventsEnabled || channel !== MCP_EVENT_CHANNEL);
}

/** Serialised `channel:mode,...` URL filter, minus any MCP entry when the flag is off. */
export function sanitiseChannelsParam(param: string | null, mcpEventsEnabled: boolean): string | null {
  if (!param || mcpEventsEnabled) return param;
  const kept = param.split(",").filter((entry) => entry.split(":")[0] !== MCP_EVENT_CHANNEL);
  return kept.length > 0 ? kept.join(",") : null;
}

/** Role names out of a `getMyRolesV3` GraphQL response body. */
export function parseRoleNames(payload: unknown): string[] {
  const nodes = (payload as { data?: { roles?: { nodes?: unknown } } } | null)?.data?.roles?.nodes;
  if (!Array.isArray(nodes)) return [];
  return nodes.flatMap((node) => (typeof node?.name === "string" ? [node.name] : []));
}
